var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportFilter_1;
import { DateConverter, JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './importFilterOperand'; // force import for JSON schema
import { ImportFilterLiteralTypes, ImportFilterOperandTypes } from './importFilterOperand';
export var ImportFilterTypes;
(function (ImportFilterTypes) {
    ImportFilterTypes["STATEMENT"] = "statement";
    ImportFilterTypes["GROUP"] = "group";
})(ImportFilterTypes || (ImportFilterTypes = {}));
export var ImportFilterOperations;
(function (ImportFilterOperations) {
    // groups
    ImportFilterOperations["AND"] = "and";
    ImportFilterOperations["OR"] = "or";
    // statements
    ImportFilterOperations["LESS_THAN"] = "less_than";
    ImportFilterOperations["LESS_THAN_EQUALS"] = "less_than_equals";
    ImportFilterOperations["EQUALS"] = "equals";
    ImportFilterOperations["NOT_EQUALS"] = "not_equals";
    ImportFilterOperations["GREATER_THAN_EQUALS"] = "greater_than_equals";
    ImportFilterOperations["GREATER_THAN"] = "greater_than";
    ImportFilterOperations["IS_NULL"] = "is_null";
    ImportFilterOperations["IS_NOT_NULL"] = "is_not_null";
    ImportFilterOperations["STARTS_WITH"] = "starts_with";
    ImportFilterOperations["ENDS_WITH"] = "ends_with";
    ImportFilterOperations["CONTAINS"] = "contains";
    ImportFilterOperations["NOT_CONTAINS"] = "not_contains";
})(ImportFilterOperations || (ImportFilterOperations = {}));
export var FilterStatementErrors;
(function (FilterStatementErrors) {
    FilterStatementErrors["LITERAL_TO_NULL"] = "LITERAL_TO_NULL";
    FilterStatementErrors["LITERAL_TO_LITERAL"] = "LITERAL_TO_LITERAL";
    FilterStatementErrors["LHS_TO_NULL_HAS_RHS"] = "LHS_TO_NULL_HAS_RHS";
    FilterStatementErrors["NO_METADATA"] = "NO_METADATA";
    FilterStatementErrors["LHS_MISMATCH_METADATA"] = "LHS_MISMATCH_METADATA";
    FilterStatementErrors["RHS_MISMATCH_METADATA"] = "RHS_MISMATCH_METADATA";
    FilterStatementErrors["LHS_MISMATCH_RHS"] = "LHS_MISMATCH_RHS";
    FilterStatementErrors["LHS_REQUIRED"] = "LHS_REQUIRED";
    FilterStatementErrors["RHS_REQUIRED"] = "RHS_REQUIRED";
    FilterStatementErrors["LHS_MUST_BE_NUMERIC"] = "LHS_MUST_BE_NUMERIC";
    FilterStatementErrors["RHS_MUST_BE_NUMERIC"] = "RHS_MUST_BE_NUMERIC";
    FilterStatementErrors["LHS_MUST_BE_BOOLEAN"] = "LHS_MUST_BE_BOOLEAN";
    FilterStatementErrors["RHS_MUST_BE_BOOLEAN"] = "RHS_MUST_BE_BOOLEAN";
    FilterStatementErrors["LHS_MUST_BE_STRING"] = "LHS_MUST_BE_STRING";
    FilterStatementErrors["RHS_MUST_BE_STRING"] = "RHS_MUST_BE_STRING";
    FilterStatementErrors["LHS_BOOLEAN_WRONG_OP"] = "LHS_BOOLEAN_WRONG_OP";
    FilterStatementErrors["RHS_BOOLEAN_WRONG_OP"] = "RHS_BOOLEAN_WRONG_OP";
    FilterStatementErrors["LHS_MUST_BE_DATE"] = "LHS_MUST_BE_DATE";
    FilterStatementErrors["RHS_MUST_BE_DATE"] = "RHS_MUST_BE_DATE"; // rhs must be date because lhs is date column
})(FilterStatementErrors || (FilterStatementErrors = {}));
const schema = {
    $id: 'urn:wisepipe-common-data:ImportFilter',
    type: 'object',
    properties: {
        op: { type: 'string', enum: Object.values(ImportFilterOperations) },
        filterType: { type: 'string', enum: Object.values(ImportFilterTypes) },
        filters: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:ImportFilter' }
        },
        lhs: { $ref: 'urn:wisepipe-common-data:ImportFilterOperand' },
        rhs: { $ref: 'urn:wisepipe-common-data:ImportFilterOperand' }
    },
    required: ['op', 'filterType'],
    if: { properties: { filterType: { const: ImportFilterTypes.GROUP } } },
    then: { required: ['filters'] },
    else: { required: ['lhs', 'op'] }
};
let ImportFilter = ImportFilter_1 = class ImportFilter {
    constructor(op, filterType, filters, lhs, rhs) {
        this.op = op;
        this.filterType = filterType;
        this.filters = filters;
        this.lhs = lhs;
        this.rhs = rhs;
        JSON.validate(this, ImportFilter_1);
    }
    validateCols(errors, col, lit, op, isColLeft) {
        const val = lit ? lit.value : undefined;
        const litType = lit ? lit.litType : undefined;
        const defaultTarget = isColLeft ? 'rhs' : 'lhs';
        if (val === undefined || val === null || val === '') {
            errors.push({
                target: defaultTarget,
                messageKey: isColLeft ? FilterStatementErrors.RHS_REQUIRED : FilterStatementErrors.LHS_REQUIRED
            });
        }
        else if (col.type === 'string') {
            if (litType !== ImportFilterLiteralTypes.STRING) {
                errors.push({
                    target: defaultTarget,
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_STRING : FilterStatementErrors.LHS_MUST_BE_STRING
                });
            }
        }
        else if (col.type === 'number') {
            if (litType !== ImportFilterLiteralTypes.NUMBER || isNaN(val)) {
                errors.push({
                    target: defaultTarget,
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_NUMERIC : FilterStatementErrors.LHS_MUST_BE_NUMERIC
                });
            }
            if (op === ImportFilterOperations.STARTS_WITH ||
                op === ImportFilterOperations.ENDS_WITH ||
                op === ImportFilterOperations.CONTAINS ||
                op === ImportFilterOperations.NOT_CONTAINS) {
                errors.push({
                    target: 'op',
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_STRING : FilterStatementErrors.LHS_MUST_BE_STRING
                });
            }
        }
        else if (col.type === 'boolean') {
            if (litType !== ImportFilterLiteralTypes.BOOLEAN ||
                (val.toLowerCase() !== 'true' && val.toLowerCase() !== 'false')) {
                errors.push({
                    target: defaultTarget,
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_BOOLEAN : FilterStatementErrors.LHS_MUST_BE_BOOLEAN
                });
            }
            if (op === ImportFilterOperations.GREATER_THAN ||
                op === ImportFilterOperations.GREATER_THAN_EQUALS ||
                op === ImportFilterOperations.LESS_THAN ||
                op === ImportFilterOperations.LESS_THAN_EQUALS) {
                errors.push({
                    target: 'op',
                    messageKey: isColLeft
                        ? FilterStatementErrors.RHS_BOOLEAN_WRONG_OP
                        : FilterStatementErrors.LHS_BOOLEAN_WRONG_OP
                });
            }
            else if (op === ImportFilterOperations.STARTS_WITH ||
                op === ImportFilterOperations.ENDS_WITH ||
                op === ImportFilterOperations.CONTAINS ||
                op === ImportFilterOperations.NOT_CONTAINS) {
                errors.push({
                    target: 'op',
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_STRING : FilterStatementErrors.LHS_MUST_BE_STRING
                });
            }
        }
        else if (col.type === 'date') {
            if (litType !== ImportFilterLiteralTypes.DATE ||
                !DateConverter.isDate(val) ||
                !RegExp(`^\\d*-\\d*-\\d*([TZ\\d:.]*)?$`).test(val)) {
                errors.push({
                    target: defaultTarget,
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_DATE : FilterStatementErrors.LHS_MUST_BE_DATE
                });
            }
            if (op === ImportFilterOperations.STARTS_WITH ||
                op === ImportFilterOperations.ENDS_WITH ||
                op === ImportFilterOperations.CONTAINS ||
                op === ImportFilterOperations.NOT_CONTAINS) {
                errors.push({
                    target: 'op',
                    messageKey: isColLeft ? FilterStatementErrors.RHS_MUST_BE_STRING : FilterStatementErrors.LHS_MUST_BE_STRING
                });
            }
        }
    }
    validate(source) {
        if (this.filterType !== ImportFilterTypes.STATEMENT) {
            return [];
        }
        const errors = [];
        const { rhs, lhs, op } = this;
        if (op === ImportFilterOperations.IS_NULL || op === ImportFilterOperations.IS_NOT_NULL) {
            if (lhs.operandType === ImportFilterOperandTypes.LITERAL) {
                errors.push({ target: 'lhs', messageKey: FilterStatementErrors.LITERAL_TO_NULL });
            }
            if (source && source.length !== 0) {
                const leftCol = source.find((col) => col.name === lhs.name);
                if (!leftCol) {
                    errors.push({ target: 'lhs', messageKey: FilterStatementErrors.LHS_MISMATCH_METADATA });
                }
            }
            if (rhs) {
                errors.push({ target: 'rhs', messageKey: FilterStatementErrors.LHS_TO_NULL_HAS_RHS });
            }
            return errors;
        }
        if (lhs.operandType === ImportFilterOperandTypes.LITERAL &&
            rhs &&
            rhs.operandType === ImportFilterOperandTypes.LITERAL) {
            errors.push({ target: 'lhs', messageKey: FilterStatementErrors.LITERAL_TO_LITERAL });
        }
        if (!source || source.length === 0) {
            errors.push({ target: 'op', messageKey: FilterStatementErrors.NO_METADATA });
        }
        else {
            let leftCol;
            let rightCol;
            if (lhs.operandType === ImportFilterOperandTypes.COLUMN) {
                leftCol = source.find((col) => col.name === lhs.name);
                if (!leftCol) {
                    errors.push({ target: 'lhs', messageKey: FilterStatementErrors.LHS_MISMATCH_METADATA });
                }
                else if (leftCol.type !== 'string' &&
                    (op === ImportFilterOperations.STARTS_WITH ||
                        op === ImportFilterOperations.ENDS_WITH ||
                        op === ImportFilterOperations.CONTAINS ||
                        op === ImportFilterOperations.NOT_CONTAINS)) {
                    errors.push({ target: 'op', messageKey: FilterStatementErrors.LHS_MUST_BE_STRING });
                }
            }
            if (rhs && rhs.operandType === ImportFilterOperandTypes.COLUMN) {
                rightCol = source.find((col) => col.name === rhs.name);
                if (!rightCol) {
                    errors.push({ target: 'rhs', messageKey: FilterStatementErrors.RHS_MISMATCH_METADATA });
                }
                else if (rightCol.type !== 'string' &&
                    (op === ImportFilterOperations.STARTS_WITH ||
                        op === ImportFilterOperations.ENDS_WITH ||
                        op === ImportFilterOperations.CONTAINS ||
                        op === ImportFilterOperations.NOT_CONTAINS)) {
                    errors.push({ target: 'op', messageKey: FilterStatementErrors.RHS_MUST_BE_STRING });
                }
            }
            if (leftCol && rightCol && leftCol.type !== rightCol.type) {
                errors.push({ target: 'rhs', messageKey: FilterStatementErrors.LHS_MISMATCH_RHS });
            }
            if (errors.length > 0)
                return errors;
            if (leftCol && !rightCol) {
                const rLit = rhs ? rhs : undefined;
                this.validateCols(errors, leftCol, rLit, op, true);
            }
            if (rightCol && !leftCol) {
                const lLit = lhs ? lhs : undefined;
                this.validateCols(errors, rightCol, lLit, op, false);
            }
        }
        return errors;
    }
};
ImportFilter = ImportFilter_1 = __decorate([
    JsonSchema(schema)
], ImportFilter);
export { ImportFilter };
//# sourceMappingURL=importFilter.js.map